import { useMutation } from '@tanstack/react-query'
import { updateFundingNeed } from '@/api/fundingNeedsAPI'

/**
 * Appends additional text to a funding need's description via PATCH.
 * Uses force + ignore_assessment to skip re-assessment on save.
 *
 * Caller must provide the current description so the hook can
 * concatenate and send the full updated text.
 */
export function useAppendFundingDescription() {
  return useMutation({
    mutationFn: async ({
      token,
      needId,
      currentDescription,
      additionalText,
    }: {
      token: string
      needId: number
      currentDescription: string
      additionalText: string
    }) => {
      const newDescription = currentDescription
        ? `${currentDescription}\n\n${additionalText}`
        : additionalText

      return updateFundingNeed({
        token,
        fundingNeedId: needId,
        updates: {
          description: newDescription,
          accepts_gambling_proceeds: false,
          accepts_international: false,
          force: true,
          ignore_assessment: true,
        },
      })
    },
  })
}
